export const isDesktop = (browser) => {
  const { infinity, large, extraLarge } = browser?.is || {};
  return !!(infinity || large || extraLarge);
};

export const isMedium = (browser) => {
  const { extraLarge, large, infinity, medium } = browser?.is || {};
  return !!(extraLarge || large || infinity || medium);
};

export const isMobiles = (browser) => {
  const { medium, small, extraSmall } = browser?.is || {};
  return !!(small || extraSmall || medium);
};

export const isTouchDevice = () => {
  if (typeof window === 'undefined') return false;
  return navigator.maxTouchPoints > 0 || window.matchMedia("(pointer: coarse)").matches;
};
